import { render, staticRenderFns } from "./ButtonsCarrusel.vue?vue&type=template&id=b48f778e&scoped=true"
import script from "./ButtonsCarrusel.vue?vue&type=script&lang=js"
export * from "./ButtonsCarrusel.vue?vue&type=script&lang=js"
import style0 from "./ButtonsCarrusel.vue?vue&type=style&index=0&id=b48f778e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48f778e",
  null
  
)

export default component.exports